import { render } from "./SettingPotongan.vue?vue&type=template&id=21a73058&scoped=true"
import script from "./SettingPotongan.vue?vue&type=script&lang=js"
export * from "./SettingPotongan.vue?vue&type=script&lang=js"

import "./SettingPotongan.vue?vue&type=style&index=0&id=21a73058&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a73058"]])

export default __exports__